import { SectionWrapper } from "../SectionWrapper";
import { Badge, Box, Flex, SimpleGrid, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import React from "react";

interface MockNetworkActivityData {
  date: string;
  searches: number;
  views: number;
  pins: number;
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  networkActivityData: MockNetworkActivityData[];
}

// Constants to prevent inline object creation
const GRID_PROPS = { columns: 3, spacing: "1rem", px: "1rem" };
const STACK_PROPS = { align: "center" as const, spacing: "0.5rem" };
const CHART_HEIGHT = "150px";
const CHART_STROKE_DASH = "3 3";
const CHART_FONT_SIZE = "10px";
const SEARCHES_STROKE = "#3182ce";
const VIEWS_STROKE = "#f56565";
const STROKE_WIDTH = 2;

function SectionNetworkActivity({ networkActivityData, ...props }: Props) {
  const textColor = useColorModeValue("primary.darkGray", "gray.400");

  return (
    <SectionWrapper title="Capital Markets Network Activity" {...props}>
      <SimpleGrid {...GRID_PROPS}>
        <Stack {...STACK_PROPS}>
          <Text fontSize="xs" color={textColor}>
            Searches
          </Text>
          <Text fontSize="2xl" color="charli.primaryBlue">
            425
          </Text>
        </Stack>
        <Stack {...STACK_PROPS}>
          <Text fontSize="xs" color={textColor}>
            Views
          </Text>
          <Text fontSize="2xl" color="charli.primaryBlue">
            28
          </Text>
        </Stack>
        <Stack {...STACK_PROPS}>
          <Text fontSize="xs" color={textColor}>
            Pins
          </Text>
          <Text fontSize="2xl" color="charli.primaryBlue">
            3
          </Text>
        </Stack>
      </SimpleGrid>

      {/* Chart */}
      <Box height={CHART_HEIGHT} pr="1rem">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={networkActivityData}>
            <CartesianGrid strokeDasharray={CHART_STROKE_DASH} />
            <XAxis dataKey="date" fontSize={CHART_FONT_SIZE} />
            <YAxis fontSize={CHART_FONT_SIZE} />
            <Tooltip />
            <Line type="monotone" dataKey="searches" stroke={SEARCHES_STROKE} strokeWidth={STROKE_WIDTH} />
            <Line type="monotone" dataKey="views" stroke={VIEWS_STROKE} strokeWidth={STROKE_WIDTH} />
          </LineChart>
        </ResponsiveContainer>
      </Box>

      <Flex justify="flex-start" pl="1rem">
        <Badge size="sm" colorScheme="blue" variant="outline">
          7-Days
        </Badge>
      </Flex>
    </SectionWrapper>
  );
}

export default React.memo(SectionNetworkActivity);
